import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {ABERRATION_COMPONENTS, ABERRATION_SERVICES} from './index';
import {LayoutModule} from '../../layout/layout.module';
import {EditorModule} from 'primeng/editor';
import {DashboardModule} from '../dashboard.module';
import {CurationStatusComponent} from './components/curation-status/curation-status.component';
import {ColorTextColumnComponent} from './components/color-text-column/color-text-column.component';
import {CoreModule} from '../../core/core.module';
import {CurationActionComponent} from './components/curation-action/curation-action.component';
import {NotesModule} from '../../notes/notes.module';
import {DecimalFormattedColumnComponent} from './components/decimal-formatted-column/decimal-formatted-column.component';
import {ColorBoxColumnComponent} from './components/color-box-column/color-box-column.component';
import {WorkflowConfigModule} from '@ispm/workflow/workflow-config.module';
import {FilterModule} from '../../filter/filter.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    EditorModule,
    LayoutModule,
    CoreModule,
    NotesModule,
    WorkflowConfigModule,
    DashboardModule,
    FilterModule
  ],
  declarations: [...ABERRATION_COMPONENTS, CurationStatusComponent, CurationActionComponent, ColorTextColumnComponent, DecimalFormattedColumnComponent,
    ColorBoxColumnComponent],
  providers: [...ABERRATION_SERVICES],
    exports: [...ABERRATION_COMPONENTS]
})
export class AberrationsModule { }
